export default __webpack_public_path__ + "images/HD.4474783.png";